module.exports = __webpack_public_path__ + "img/hr-H-B-6-unload-standup-shadow.41011637.png";